import Trophy from '@assets/icons/trophy.svg'
import { Icon } from './Icon'

export const TrophyIcon = Icon(Trophy)
